import {
    getAmaronCalendarDisplayMetrics,
    resolveAmaronCalendarDisplayMetricsModuleFromEventTemplateId,
    type AmaronCalendarDisplayMetricsContext,
} from "~/domainModels/calendarDisplayMetrics/amaron";
import type {CalendarDisplayMetricsConfig, CalendarDisplayMetricVisibilityContext} from "~/domainModels/calendarDisplayMetrics/types";
import {isAmaronWorkspace} from "~/domainModels/workspaceSpecific/amaron";
import type {WorkspaceCapability} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapability";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export type ResolveCalendarDisplayMetricsContext =
    | ({
          workspace: "amaron";
      } & AmaronCalendarDisplayMetricsContext)
    | {
          workspace: "unknown";
      };

export function resolveCalendarDisplayMetrics(
    workspaceCapabilities: Array<WorkspaceCapability>,
    ctx: ResolveCalendarDisplayMetricsContext,
): CalendarDisplayMetricsConfig | undefined {
    if (isAmaronWorkspace(workspaceCapabilities) !== true || ctx.workspace !== "amaron") {
        return undefined;
    }
    return getAmaronCalendarDisplayMetrics(ctx);
}

export function resolveAmaronEventCalendarDisplayMetrics(
    workspaceCapabilities: Array<WorkspaceCapability>,
    args: {
        eventTemplateId: Uuid;
        statusId?: string | null;
    },
): CalendarDisplayMetricsConfig | undefined {
    if (isAmaronWorkspace(workspaceCapabilities) !== true) {
        return undefined;
    }
    const module = resolveAmaronCalendarDisplayMetricsModuleFromEventTemplateId(args.eventTemplateId);
    if (module === undefined) {
        return undefined;
    }
    return getAmaronCalendarDisplayMetrics({
        module: module,
        statusId: args.statusId,
    });
}

export function resolveAmaronJourneyCalendarDisplayMetrics(
    workspaceCapabilities: Array<WorkspaceCapability>,
    args: {
        isInQueueView: boolean;
        statusId?: string | null;
    },
): CalendarDisplayMetricsConfig | undefined {
    if (isAmaronWorkspace(workspaceCapabilities) !== true) {
        return undefined;
    }
    return getAmaronCalendarDisplayMetrics({
        module: args.isInQueueView === true ? "journeysInQueue" : "journeysLeads",
        statusId: args.statusId,
    });
}

export type {CalendarDisplayMetricVisibilityContext};
